import type { TCountryCode } from 'countries-list'
import { getEmojiFlag } from 'countries-list'

export const WORLD_JURISDICTIONS = [
  { value: 'WO', label: `WIPO ${getEmojiFlag('UN' as TCountryCode)}` },
] as const

export const NORTH_AMERICA_JURISDICTIONS = [
  { value: 'US', label: `USA ${getEmojiFlag('US')}` },
  {
    value: 'CA',
    label: `Canada ${getEmojiFlag('CA')}`,
  },
] as const

export const EUROPE_JURISDICTIONS = [
  { value: 'EP', label: `EPO ${getEmojiFlag('EU' as TCountryCode)}` },
  { value: 'CH', label: `Switzerland ${getEmojiFlag('CH')}` },
  { value: 'DE', label: `Germany ${getEmojiFlag('DE')}` },
  { value: 'ES', label: `Spain ${getEmojiFlag('ES')}` },
  { value: 'FR', label: `France ${getEmojiFlag('FR')}` },
  { value: 'GB', label: `United Kingdom ${getEmojiFlag('GB')}` },
  { value: 'IT', label: `Italy ${getEmojiFlag('IT')}` },
] as const

export const ASIA_JURISDICTIONS = [
  { value: 'CN', label: `China ${getEmojiFlag('CN')}` },
  { value: 'JP', label: `Japan ${getEmojiFlag('JP')}` },
  { value: 'KR', label: `Korea ${getEmojiFlag('KR')}` },
  { value: 'IN', label: `India ${getEmojiFlag('IN')}` },
] as const

export const AUSTRALASIA_JURISDICTIONS = [
  { value: 'AU', label: `Australia ${getEmojiFlag('AU')}` },
] as const

const MIDDLE_EAST_JURISDICTIONS = [
  { value: 'IL', label: `Israel ${getEmojiFlag('IL')}` },
] as const

const SOUTH_AMERICA_JURISDICTIONS = [
  { value: 'AR', label: `Argentina ${getEmojiFlag('AR')}` },
  { value: 'BR', label: `Brazil ${getEmojiFlag('BR')}` },
] as const

export const JURISDICTIONS = [
  { label: 'WORLD', options: WORLD_JURISDICTIONS },
  { label: 'NORTH AMERICA', options: NORTH_AMERICA_JURISDICTIONS },
  { label: 'EUROPE', options: EUROPE_JURISDICTIONS },
  { label: 'ASIA', options: ASIA_JURISDICTIONS },
  { label: 'AUSTRALASIA', options: AUSTRALASIA_JURISDICTIONS },
  { label: 'SOUTH AMERICA', options: SOUTH_AMERICA_JURISDICTIONS },
  { label: 'MIDDLE EAST', options: MIDDLE_EAST_JURISDICTIONS },
] as const

export type Jurisdiction =
  (typeof JURISDICTIONS)[number]['options'][number]['value']

export const JURISDICTIONS_LABELS = Object.fromEntries(
  JURISDICTIONS.flatMap((item) =>
    item.options.map((jur) => [jur.value, jur.label])
  )
)
export const JURISDICTION_VALUES = JURISDICTIONS.flatMap((jurisdiction) =>
  jurisdiction.options.map((option) => option.value)
) as [string, ...string[]]
